/*@ngInject*/
const RejectSubmissionRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.reject = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/reject',
            config = {
                params: {
                    reason: reason,
                    detail: detail,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('rejectSubmissionRepository', RejectSubmissionRepository);
